<div class="job-dialog">

  <div class="content">

    <h3> {{ isNew ? 'Nouveau job item' : 'Editer job item' }} </h3>

    <!-- {{ job$ | async | json }}  -->

    <form #jobForm="ngForm" class="job-form">

      <mat-form-field>
        <mat-label>Tache standard</mat-label>
        <mat-select required name="jobTask" [(ngModel)]="jobItem.jobTaskId">
          @for (task of (jobTasks$ | async); track task) {
            <mat-option [value]="task.id" >{{task.id}} - {{task.code}} {{task.title}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!--
      <mat-form-field>
        <mat-label>Service</mat-label>
        <mat-select required name="serviceType" [(ngModel)]="jobItem.serviceType">
          <mat-option *ngFor="let type of serviceTypesBD" [value]="type.code" >{{type.title}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Type d'activité/prestation</mat-label>
        <mat-select required name="jobType" [(ngModel)]="job.jobType">
          <mat-option *ngFor="let type of jobTypesBD" [value]="type.code" >{{type.title}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="job.serviceType === ServiceType.KEEP_REPAIR">
        <mat-label>Catégorie de prestations</mat-label>
        <mat-select name="jobCategories" multiple [(ngModel)]="job.jobCategories">
          <mat-option *ngFor="let serv of jobCategoriesBD" [value]="serv.code" >{{serv.title}}</mat-option>
        </mat-select>
      </mat-form-field>
      -->

      <mat-form-field >
        <mat-label >Titre</mat-label>
        <input required matInput type="text" matNativeControl  name ="title" placeholder="Titre"  [(ngModel)]="jobItem.title" >
      </mat-form-field>

      <mat-form-field >
        <mat-label >Description</mat-label>
        <textarea required matInput type="text"  name ="description" placeholder=""  [(ngModel)]="jobItem.description" ></textarea>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Quantité</mat-label>
        <input type="number" required matInput="" name ="quantity" step="1" placeholder="Quantité"  [(ngModel)]="jobItem.quantity" >
      </mat-form-field>

      <mat-form-field >
        <mat-label>Prix vente unitaire ({{jobItem.currency}}) </mat-label>
        <input type="number" required minlength=3 matInput="" name ="unitAmount" step="1000" placeholder="Prix vente unitaire"  [(ngModel)]="jobItem.unitAmount" >
      </mat-form-field>


    </form>
  </div>

  <div mat-dialog-actions>
    <button class="simple-button" mat-button [mat-dialog-close]="">Annuler</button>
    <button class="simple-button" [disabled] = !jobForm.valid mat-button [mat-dialog-close]="jobItem" (click)="submitJobItem();$event.stopPropagation()"> Soumettre </button>
  </div>
</div>